import { render, staticRenderFns } from "./ImageTags.vue?vue&type=template&id=24ad61bf&"
import script from "./ImageTags.vue?vue&type=script&lang=js&"
export * from "./ImageTags.vue?vue&type=script&lang=js&"
import style0 from "./ImageTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports